import React from "react"
import { Link } from "react-router-dom"

export default function TeamDetails1() {
	return (
		<>
			<section className="team-details-section fix section-padding">
				<div className="container">
					<div className="team-details-wrapper">
						<div className="team-details-items">
							<div className="details-image">
								<img src="assets/img/team/Team_1.png" alt="V-Make dealer and distributor partnership program illustration" />
							</div>
							<div className="team-details-content">
								<div className="details-header">
									<h3>Become a Dealer / Distributor</h3>
									<h5 className="mt-4">Partner with V-Make – Build a Stronger Tomorrow</h5>
									{/* <span>Sr. engineer</span> */}
								</div>
								<p className="cont">
									Join V-Make as a dealer/distributor to help us deliver premium WPC Doors, Frames, and Boards across India.

									Whether you’re an established dealer or looking to expand into a high-demand segment, partnering with V-Make ensures long-term value, technical support, and market-ready products that drive trust and profits
								</p>

								<div className="col-lg-5">
									<div className="content">
										<h3>Why Join Us ?</h3>
										{/* <p className="mt-2 mb-2">
												100% waterproof and termite-proof
												</p>
												<p>
													Trastek h variations of be passages of Lorem Ipsum
													available,
												</p> */}
									</div>
									<ul className="details-list mt-3 mb-3">
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}Backed by German Technology
										</li>
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}High-Margin, High-Demand Products
										</li>
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}End-to-End Marketing Support
										</li>
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}Dealer Training & Technical Know-How
										</li>
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}Strong Brand with Pan-India Presence
										</li>
										<li className="mt-1 mb-1">
											<i className="fa-solid fa-circle-check" />
											{"  "}Fast Products & Custom Options

										</li>
									</ul>
								</div>

								{/* <h6 className="team-details-info">
									<span className="text-title">Phone Number:</span>
									<span className="text-data">
										<Link to="/tel:+915690036420">+91 5698 0036 420</Link>
									</span>
								</h6>
								<h6 className="team-details-info">
									<span className="text-title">Email:</span>
									<span className="text-data">
										<Link to="/mailto:example@gmail.com">
											example@gmail.com
										</Link>
									</span>
								</h6>
								<h6 className="team-details-info">
									<span className="text-title">Website:</span>
									<span className="text-data">
										<Link to="/team-details">http://example.com/example</Link>
									</span>
								</h6>
								<h6 className="team-details-info">
									<span className="text-title">Experience:</span>
									<span className="text-data">15 Years</span>
								</h6>
								<h6 className="team-details-info">
									<span className="text-title">Availability:</span>
									<span className="text-data">Full Time Employee</span>
								</h6> */}
								{/* <div className="social-icon d-flex align-items-center">
									<Link to="/#">
										<i className="fab fa-facebook-f" />
									</Link>
									<Link to="/#">
										<i className="fab fa-twitter" />
									</Link>
									<Link to="/#">
										<i className="fab fa-youtube" />
									</Link>
									<Link to="/#">
										<i className="fab fa-linkedin-in" />
									</Link>
								</div> */}
							</div>
						</div>
						<div className="personal-skills-items">
							<div className="row g-5">
								<div className="col-lg-5">
									<h3 className="mb-3">About Our Dealer Program</h3>
									<p>
										At V-Make, we believe growth happens together. Our dealer and distributor network forms the foundation of our reach across India, helping us deliver premium WPC doors and frames with efficiency and trust. By partnering with us, you're not just selling a product — you're offering cutting-edge solutions in modern construction.
									</p>
									<p className="mt-4">
										With German-engineered manufacturing, quick lead times, and versatile designs, our dealers enjoy excellent margins, brand recognition, and exclusive support to grow their business in local markets.
									</p>
								</div>
								<div className="col-lg-7">
									<h3 className="mb-3">Partnership Strengths</h3>
									<p>
										Our success is built on the strength of our extensive dealer network across India. We carefully collaborate with partners who bring invaluable local market insights, proven distribution capabilities, and an unwavering commitment to customer satisfaction. Our dealers understand regional preferences, maintain strong relationships with contractors and architects, and provide expert product guidance. Through this strategic partnership, we ensure V-Make products reach every corner of the country with consistent quality, timely delivery, and exceptional service support. Our dealers also benefit from our comprehensive training programs, marketing tools, and technical expertise to better serve their customers and grow their business.
									</p>
									{/* <div className="skill-feature-items">
										<div className="skill-feature">
											<h3 className="box-title">Market Knowledge</h3>
											<div className="progress">
												<div
													className="progress-bar"
													style={{
														width: "85%",
														animation:
															"2.6s ease 0s 1 normal none running animate-positive",
														opacity: "1",
													}}
												>
													<div className="progress-value">
														<span className="counter-number2">85</span>%
													</div>
												</div>
											</div>
										</div>
										<div className="skill-feature">
											<h3 className="box-title">Sales & Distribution Reach</h3>
											<div className="progress">
												<div
													className="progress-bar"
													style={{
														width: "90%",
														animation:
															"2.6s ease 0s 1 normal none running animate-positive",
														opacity: "1",
													}}
												>
													<div className="progress-value">
														<span className="counter-number2">90</span>%
													</div>
												</div>
											</div>
										</div>
										<div className="skill-feature">
											<h3 className="box-title">After-Sales Support Capability</h3>
											<div className="progress">
												<div
													className="progress-bar"
													style={{
														width: "75%",
														animation:
															"2.6s ease 0s 1 normal none running animate-positive",
														opacity: "1",
													}}
												>
													<div className="progress-value">
														<span className="counter-number2">75</span>%
													</div>
												</div>
											</div>
										</div>
									</div> */}
								</div>
							</div>
						</div>
						{/* <div className="team-gallery-items">
							<h3 className="mb-md-3">My Work Gallery</h3>
							<div className="row">
								<div className="col-xl-4 col-lg-6 col-md-6">
									<div className="gallery-thumb">
										<img src="assets/img/team/gallery-1.jpg" alt="img" />
									</div>
								</div>
								<div className="col-xl-4 col-lg-6 col-md-6">
									<div className="gallery-thumb">
										<img src="assets/img/team/gallery-2.jpg" alt="img" />
									</div>
								</div>
								<div className="col-xl-4 col-lg-6 col-md-6">
									<div className="gallery-thumb">
										<img src="assets/img/team/gallery-3.jpg" alt="img" />
									</div>
								</div>
							</div>
						</div> */}
					</div>
				</div>
			</section>
		</>
	)
}
